import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { useI18n } from '@oneaudi/i18n-context';
import { Icon, iconSystemInfoSmall } from './icon';
import { SYS_SIZE_FIXED_250, SYS_BREAKPOINT_MD, SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT, SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DEFAULT_LIGHT, SEM_COLOR_FORMS_FOREGROUND_TEXT_DEFAULT_LIGHT, SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_250, } from '@oneaudi/unified-web-common';
import { SEM_COLOR_FORMS_FOREGROUND_TEXT_DEFAULT_DARK, SYS_GRADIENT_ELEVATION_LEVEL2_FILL_DARK, SYS_COLOR_ELEVATION_LEVEL2_STROKE_DARK, SYS_BORDER_RADIUS_MD, } from '@oneaudi/unified-web-alpha-common';
import { DynamicComponent, dynamicStyling } from '../rethink/utils/AlphaHelper';
import { IconButton } from '@oneaudi/unified-web-components';
export const RenderedMarkerPLPPDP = ({ picture, padding, top, left, isPDP }) => {
    const popupContent = useI18n({
        id: 'nemo.ui.sc.stage.renderedDisclaimer',
        defaultMessage: '',
    });
    const renderImageAriaLabel = useI18n({
        id: 'stockcars.images.renderimages.arialabel',
        defaultMessage: '',
    });
    const [popupButtonBottom, setPopupButtonBottom] = useState(0);
    const [popupButtonLeft, setPopupButtonLeft] = useState(0);
    const popupButtonRef = useRef(null);
    const [open, setOpen] = useState(false);
    const clickHandler = (evt) => {
        var _a;
        evt.preventDefault();
        evt.stopPropagation();
        const popupButtonCord = (_a = popupButtonRef === null || popupButtonRef === void 0 ? void 0 : popupButtonRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (popupButtonCord) {
            setPopupButtonBottom(popupButtonCord.bottom + document.documentElement.scrollTop);
            setPopupButtonLeft(popupButtonCord.left);
        }
        setOpen(true);
        if (evt.type === 'click')
            setTimeout(() => setOpen(false), 4000);
    };
    const preventEventAction = (evt, withPreventDefault = true) => {
        if (withPreventDefault)
            evt.preventDefault();
        evt.stopPropagation();
    };
    const handleScroll = () => {
        setOpen(false);
    };
    useEffect(() => {
        window.removeEventListener('scroll', handleScroll);
        window.addEventListener('scroll', handleScroll, { passive: true });
        const buttonContainer = popupButtonRef === null || popupButtonRef === void 0 ? void 0 : popupButtonRef.current;
        buttonContainer === null || buttonContainer === void 0 ? void 0 : buttonContainer.addEventListener('mouseenter', clickHandler);
        buttonContainer === null || buttonContainer === void 0 ? void 0 : buttonContainer.addEventListener('mouseleave', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            buttonContainer === null || buttonContainer === void 0 ? void 0 : buttonContainer.removeEventListener('mouseenter', clickHandler);
            buttonContainer === null || buttonContainer === void 0 ? void 0 : buttonContainer.removeEventListener('mouseleave', handleScroll);
        };
    }, []);
    if (!picture || !isTypedPicture(picture) || picture.type !== 'render') {
        return null;
    }
    if (!popupContent.trim()) {
        return null;
    }
    return (React.createElement(PopupContainer, { top: top, left: left },
        React.createElement(DynamicComponent, { legacy: React.createElement(PopupButton, { type: "button", "aria-label": renderImageAriaLabel, onClick: clickHandler, onPointerDown: (evt) => preventEventAction(evt), onPointerUp: (evt) => preventEventAction(evt), onMouseDown: (evt) => preventEventAction(evt), onTouchStart: (evt) => preventEventAction(evt, false), onTouchEnd: (evt) => preventEventAction(evt, false), "data-testid": "infoBtn", onMouseEnter: clickHandler, onMouseLeave: () => {
                    setOpen(false);
                }, ref: popupButtonRef, padding: padding },
                React.createElement(Icon, { icon: iconSystemInfoSmall })), alpha: React.createElement(TooltipButtonWrapper, { onPointerDown: (evt) => preventEventAction(evt), onPointerUp: (evt) => preventEventAction(evt), onMouseDown: (evt) => preventEventAction(evt), onTouchStart: (evt) => preventEventAction(evt, false), onTouchEnd: (evt) => preventEventAction(evt, false) },
                React.createElement(IconButton, { "aria-label": renderImageAriaLabel, onClick: clickHandler, "data-testid": "infoBtn", variant: isPDP ? 'secondary' : 'primary', size: 'xs', icon: "info-circle", ref: popupButtonRef })) }),
        open &&
            ReactDOM.createPortal(React.createElement(PopupContent, { role: "tooltip", id: picture === null || picture === void 0 ? void 0 : picture.key, top: popupButtonBottom, left: popupButtonLeft, position: parseInt(padding, 10) }, popupContent), document.body)));
};
const PopupContainer = styled.div `
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
`;
const PopupContent = styled.div `
  display: block;
  background-color: ${SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT};
  position: absolute;
  left: ${(props) => props.left + props.position - 10.5}px;
  top: ${(props) => props.top - props.position + 25}px;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
  max-width: 320px;
  word-wrap: break-word;
  z-index: 2001;
  padding: ${SYS_SIZE_FIXED_250};
  font-family: ${SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL.fontFamily};
  font-size: ${SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL.fontSize};
  color: ${SEM_COLOR_FORMS_FOREGROUND_TEXT_DEFAULT_LIGHT};
  font-weight: ${SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL.fontSize};
  font-stretch: ${SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL.fontStretch};
  text-align: left;
  line-height: ${SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL.lineHeight};
  -webkit-font-smoothing: antialiased;
  ${dynamicStyling({
    legacy: `width: 18vw;`,
    alpha: `
    background: ${SYS_GRADIENT_ELEVATION_LEVEL2_FILL_DARK};
    color: ${SEM_COLOR_FORMS_FOREGROUND_TEXT_DEFAULT_DARK};
    border-radius: ${SYS_BORDER_RADIUS_MD};
    padding: ${SYS_SPACE_FIXED_200};
    box-shadow: inset 0 0 0 1px ${SYS_COLOR_ELEVATION_LEVEL2_STROKE_DARK};
  `,
})};

  @media (max-width: ${SYS_BREAKPOINT_MD}) {
    width: 315px;
  }

  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 15px;
    width: 18px;
    height: 8px;
    clip-path: polygon(0 100%, 50% 0, 100% 100%);

    ${dynamicStyling({
    legacy: `background-color: ${SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT}`,
    alpha: `
      top: -8px;
      left: ${SYS_SPACE_FIXED_250};
      z-index: 9990;
      background: ${SYS_GRADIENT_ELEVATION_LEVEL2_FILL_DARK}`,
})};
  }
`;
const PopupButton = styled.button `
  position: absolute;
  margin: 0;
  padding: ${(props) => props.padding};
  background: none;
  border: 0;
  color: ${SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DEFAULT_LIGHT};
  cursor: pointer;
  z-index: 0;

  & svg {
    display: block;
  }

  & path {
    fill: ${SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT};
  }
`;
const TooltipButtonWrapper = styled.div `
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export function isTypedPicture(picture) {
    return 'type' in picture;
}
